import { Commit } from 'vuex';
import { RapportASignerState } from './state';

export enum RapportASignerActions {
    GET_RAPPORTS_INTERVENTIONS = 'GET_RAPPORTS_INTERVENTIONS',
    NAV_FILTER = 'NAV_FILTER_INTERVENTION',
    GET_XLS_RAPPORTS_A_SIGNER = 'GET_XLS_RAPPORTS_A_SIGNER'
}

export interface RapportASignerActionsTypes{
    commit: Commit,
    state: RapportASignerState,
    getters: any
}
